export var isArray = function (value) {
    return Array.isArray(value);
};
export var isPopulatedArray = function (value, length) {
    if (length === void 0) { length = 1; }
    return isArray(value) && value.length >= length;
};
export var shuffle = function (array) {
    var _a;
    var currentIndex = array.length;
    var randomIndex;
    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        _a = [
            array[randomIndex],
            array[currentIndex],
        ], array[currentIndex] = _a[0], array[randomIndex] = _a[1];
    }
    return array;
};
//# sourceMappingURL=array.js.map